<template>
  <div>
    <!-- Email Input -->
    <div :style="showInputCheckEmail ? 'display:none;' : 'display:flex;'" class="col form-group">
      <input
        id="email"
        v-model="obj.email"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.email"
      />
    </div>

    <!-- Confirm Email Input -->
    <div
      :style="showInputCheckEmail ? 'display:none;' : 'display:flex;'"
      class="col form-group mt-5"
    >
      <input
        id="emailConfirmation"
        v-model="obj.emailConfirmation"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.confirmEmail"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
    </div>

    <!-- Send Confirm Code Email Input -->
    <p
      :style="
        showInputCheckEmail && !template.secondaryTheme
          ? 'display:block; font-size:0.85rem; margin-left: 16px;'
          : showInputCheckEmail && template.secondaryTheme
          ? 'color: white !important; display:block; font-size:0.85rem; margin-left: 16px;'
          : ' display:none;'
      "
    >
      {{ $t('email.codeSent') }}
    </p>

    <div :style="showInputCheckEmail ? 'display:block;' : 'display:none;'" class="col form-group">
      <input
        id="emailConfirmation"
        v-model="codeToSend"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        :placeholder="placeholders.verificationCode"
        @keyup.enter="validateFields"
        @paste="blockPaste"
      />
      <p
        :style="
          template.secondaryTheme
            ? 'font-size:0.8rem; color: ${primaryColor}; text-align: left; color: white;'
            : `font-size:0.8rem; color: ${primaryColor}; text-align: left;`
        "
        class="mt-3 mr-4"
      >
        {{ mandatoryText }}
      </p>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'
import store from '@/store/store.js'
import { loginFB } from '../../services/ServFB.js'
import { translateApiMessage } from '@/i18n/translateApiMessage'

const lFB = new loginFB()

export default {
  name: 'EmailWithConfirmation',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    showInputCheckEmail: false,
    codeToSend: '',
    toastMessage: '',
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    primaryColor() {
      return store.state.template.primaryColor
    },
    mandatoryText() {
      return store.state.config.mandatoryCheck == true
        ? this.$t('email.mandatory')
        : this.$t('email.notMandatory')
    },
    mandatoryCheck() {
      let isMandatory = store.state.config.mandatoryCheck == true ? true : false
      return isMandatory
    },
    placeholders() {
      return {
        email: this.$t('email.placeholder'),
        confirmEmail: this.$t('email.confirmPlaceholder'),
        verificationCode: this.$t('email.verificationCodeInput'),
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))
    document.getElementById('email').focus()

    this.showInputCheckEmail = this.$store.state.isEmailSentDirect

    if (this.$store.state.emailToSendConfirmateCode) {
      this.toastMessage = this.$t('email.codeSentToast', {
        email: this.$store.state.emailToSendConfirmateCode,
      })
      this.makeToast('warning')
    }
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    /* Helpers */
    blockPaste() {
      return false
    },
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: this.$t('common.attention'),
        variant: variant,
        solid: true,
      })
    },
    translateMessage(text) {
      return translateApiMessage(text, this.$i18n)
    },
    /* Validations */
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.$store.state.isEmailSentDirect) {
        if (!this.checkEmail(this.obj.email)) {
          const warningMsg = this.obj.passport
            ? 'A valid email is required.'
            : 'É necessário um Email válido.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('warning')

          hasErrors = true
        }

        if (this.obj.email !== this.obj.emailConfirmation) {
          const warningMsg = this.obj.passport
            ? 'The emails provided are different.'
            : 'Os emails informados são diferentes.'
          this.addRegistrationError({
            msg: warningMsg,
          })
          this.toastMessage = warningMsg
          this.makeToast('warning')

          hasErrors = true
        }

        if (this.showInputCheckEmail == true) {
          if (this.codeToSend.length < 5 && store.state.config.mandatoryCheck == true) {
            const warningMsg = this.obj.passport
              ? 'Incomplete code provided.'
              : 'Código informado incompleto.'
            this.addRegistrationError({
              msg: warningMsg,
            })
            this.toastMessage = warningMsg
            this.makeToast('warning')
            hasErrors = true
          }
        }
      }

      if (!hasErrors && this.showInputCheckEmail == true) {
        let code = this.codeToSend
        if (code.length > 5 && store.state.config.mandatoryCheck == true) {
          this.checkEmailCodeToConfirmService(this.codeToSend, this.obj.email)
        } else {
          if (code.length >= 0) {
            this.checkEmailCodeToConfirmService(this.codeToSend, this.obj.email)
          } else {
            this.$store.commit('updateRegistrationObject', this.obj)
            this.$emit('next')
          }
        }
      }

      if (!hasErrors && !this.showInputCheckEmail) {
        if (this.$store.state.isEmailSentDirect) {
          this.sendEmailCodeToConfirmService(this.obj.email)
          this.showInputCheckEmail = true
        } else {
          this.checkExistingEmail(this.obj.cpf || null, this.obj.email)
        }
      }
    },
    //enviar e-mail para salvar no banco o code
    async sendEmailCodeToConfirmService(email) {
      try {
        const owner = store.state.config.ownerId
        const name = store.state.config.name
        await lFB.sendEmailCodeToConfirm(email, 0, owner, name)
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },
    //consultar no banco para ver se o code está correto
    async checkEmailCodeToConfirmService(code, email) {
      try {
        const name = store.state.config.name
        await lFB
          .checkEmailCodeToConfirm(
            code,
            this.$store.state.isEmailSentDirect ? this.$store.state.identity : email,
            name,
            this.$store.state.isEmailSentDirect,
          )
          .then(res => {
            let codesucess = res
            if (codesucess === 1) {
              this.obj.code = code
              if (this.$store.state.isEmailSentDirect) {
                this.obj.email = ''
                this.obj.emailConfirmation = ''
              }
              this.$store.commit('updateRegistrationObject', this.obj)
              this.$emit('next')
            } else {
              const warningMsg = this.$t('email.codeInvalid')
              this.addRegistrationError({
                msg: warningMsg,
              })
              this.toastMessage = warningMsg
              this.makeToast('danger')
            }
          })
      } catch (err) {
        this.toastMessage = err
        this.makeToast('danger')
      }
    },
    checkEmail(email) {
      const emailRegex = /\S+@\S+\.\S+/
      return emailRegex.test(email)
    },
    async checkExistingEmail(cpf, email) {
      try {
        const response = await lFB.checkUserEmail(
          this.config.name,
          cpf,
          email,
          this.config.systemID,
          this.config.ownerId,
        )
        if (response.header.codigo !== 1) {
          this.toastMessage = this.translateMessage(
            response.header.msg || this.$t('email.unknownVerificationError'),
          )
          this.makeToast('warning')
          return
        }
        this.showInputCheckEmail = true
        this.sendEmailCodeToConfirmService(this.obj.email)
      } catch (err) {
        const message = this.translateMessage(String(err))
        this.addRegistrationError({
          msg: message,
        })
        this.toastMessage = message
        this.makeToast('warning')
      }
    },
  },
}
</script>
